import Icon from './Icon';
import { STEPS } from '../constants/content';
import { SUPPORT_PHONE_LABEL, SUPPORT_PHONE_TEL } from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';

export default function Steps() {
  return (
    <section className="section section--soft" id="process">
      <div className="shell">
        <header className="section__head">
          <p className="kicker">How it works</p>
          <h2>From error message to clean books in three steps</h2>
          <p className="section__lede">
            Reach us however suits you. We diagnose on a secure copy and confirm the price
            before we touch anything.
          </p>
        </header>

        <ol className="steps steps--timeline">
          {STEPS.map((step) => (
            <li className="step" key={step.number}>
              <span className="step__number">{step.number}</span>
              <h3>{step.title}</h3>
              <p>{step.body}</p>
            </li>
          ))}
        </ol>

        <div className="section__actions">
          <a href={SUPPORT_PHONE_TEL} className="btn btn--green">
            <Icon name="phone" size={18} />
            Call {SUPPORT_PHONE_LABEL}
          </a>
          <button type="button" className="btn btn--green-line" onClick={openZohoChat}>
            <Icon name="chat" size={18} />
            Start live chat
          </button>
          <a href="#consultation" className="btn btn--quiet">
            Get a free check
          </a>
        </div>
      </div>
    </section>
  );
}
